import type vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';
import type vtkRenderer from '@kitware/vtk.js/Rendering/Core/Renderer';
import { identity } from './rigid';
const actors = new Map<vtkActor, { renderer: vtkRenderer; metadata: Record<string, string | number> }>();
export function observeActor(actor: vtkActor, renderer: vtkRenderer, metadata: Record<string, string | number> = { kind: 'mesh' }) {
  actors.set(actor, { renderer, metadata });
  return () => actors.delete(actor);
}
export function sceneActors() {
  return [...actors].map(([actor, { renderer, metadata }]) => ({
    ...metadata,
    volumeCount: renderer.getVolumes().length,
    volumeVisible: renderer.getVolumes()[0]?.getVisibility(),
    visible: actor.getVisibility(), opacity: actor.getProperty().getOpacity(),
    color: [...actor.getProperty().getColor()],
    pointColors: Array.from(actor.getMapper()?.getInputData()?.getPointData?.()?.getScalars?.()?.getData?.()?.slice(0, 40) || [], Number),
    bounds: [...actor.getBounds()], userMatrix: Array.from(actor.getUserMatrix() || identity()),
    pointCount: Number(actor.getMapper()?.getInputData()?.getNumberOfPoints?.() || 0),
    cellCount: Number(actor.getMapper()?.getInputData()?.getNumberOfCells?.() || 0),
    points: Array.from(actor.getMapper()?.getInputData()?.getPoints?.()?.getData()?.slice(0, 24) || [], Number),
  }));
}
